<template>
    <template v-if="caseList != null && modalReady">
        <div class="case-entrances__list-wrap" :data-action="(filteredCases.length > 3 && !listView ? 'case-entrance-swiper' : null)" :data-swiper-container="(filteredCases.length > 3 && !listView ? containerId : null)">
            <div :id="containerId">
                <div class="case-entrances__list" :class="([filteredCases.length > 3 && !listView ? 'swiper-wrapper' : 'case-entrances__list--static', allLoaded ? 'case-entrances__list--all-loaded' : null])">
                    <div v-for="(item, index) in filteredCases" :key="item.PageId" class="case-entrances__item" :class="(filteredCases.length > 3 && !listView ? 'swiper-slide' : null)" @click="getCase(item.PageId)">
                        <picture class="case-entrances__image-wrap">
                            <source :srcset="item.ImagePath" media="(min-width: 1920px)" />
                            <source :srcset="item.ImagePath" media="(min-width: 992px)" />
                            <source :srcset="item.ImagePath" media="(min-width: 480px)" />
                            <img class="case-entrances__image" :src="item.ImagePath" loading="lazy" :alt="(`${item.Name}.`)" :data-index="index" />
                        </picture>
                        <h3 class="case-entrances__item-headline">
                            <span class="case-entrances__headline-inner">
                                {{ item.Name }}
                            </span>
                            <span v-if="listView && item.label !== null && item.label !== ''" class="case-entrances__item-label">
                                {{ item.Label }}
                            </span>
                        </h3>
                        <a v-if="listView && index == 0" class="btn btn--primary">
                            <span class="btn__text">{{ translationsStore.getTranslation('Translate.UI.ReadMore').Value }}</span>
                        </a>
                    </div>
                </div>
                <div v-if="listView && !allLoaded" class="case-entrances__load-all">
                    <button class="btn btn--primary" @click="allLoaded = true">
                        <span class="btn__text">{{ translationsStore.getTranslation('Translate.UI.LoadAll').Value }}</span>
                    </button>
                </div>
                <div v-if="filteredCases.length > 3 && !listView"  class="case-entrances__nav-wrap">
                    <div class="case-entrances__pagination swiper__pagination"></div>
                    <div class="case-entrances__nav">
                        <span class="case-entrances__prev btn__prev">
                            <svg id="uuid-a3836ad2-cceb-4317-84a9-034b0af41477" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.936 11.122"><path d="m15.376,10.061l4.5-4.501L15.376,1.061M.75,5.561h18.001" style="stroke-width:1.5px;" /></svg>
                        </span>
                        <span class="case-entrances__next btn__next">
                            <svg id="uuid-a3836ad2-cceb-4317-84a9-034b0af41477" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.936 11.122"><path d="m15.376,10.061l4.5-4.501L15.376,1.061M.75,5.561h18.001" style="stroke-width:1.5px;" /></svg>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </template>
    <template v-if="selectedCase != null">
        <Teleport to="#modal">
            <div :id="(`modal${selectedCaseId}`)" class="modal">
                <div class="modal__content">
                    <div class="modal__content-inner">
                        <template v-for="item in selectedCase" :key="item.id">
                            <paragraph-item :item="item" class="modal__module"></paragraph-item>
                        </template>
                    </div>
                    <span class="modal__close" @click="deselectCase()">
                        <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.1948 7.03569L14.4683 2.97569C14.6335 2.84159 14.7678 2.67641 14.8628 2.49053C14.9578 2.30465 15.0114 2.10207 15.0203 1.89552C15.0292 1.68896 14.9931 1.48289 14.9144 1.29023C14.8357 1.09757 14.7161 0.922481 14.5629 0.775957C14.4098 0.629432 14.2265 0.514635 14.0246 0.438768C13.8227 0.362901 13.6065 0.327604 13.3896 0.335091C13.1727 0.342578 12.9597 0.392687 12.7641 0.482275C12.5685 0.571863 12.3944 0.698994 12.2528 0.85569L7.9688 4.91569L3.7058 0.84569C3.56161 0.698316 3.38773 0.580112 3.19453 0.498128C3.00133 0.416144 2.79278 0.37206 2.5813 0.368507C2.36982 0.364953 2.15976 0.402003 1.96365 0.477445C1.76753 0.552887 1.58938 0.665176 1.43982 0.807613C1.29026 0.950051 1.17236 1.11972 1.09315 1.30649C1.01393 1.49327 0.975029 1.69333 0.978761 1.89473C0.982492 2.09614 1.02878 2.29477 1.11486 2.47877C1.20095 2.66277 1.32506 2.82837 1.4798 2.96569L5.7428 7.03569L1.4693 11.0957C1.17436 11.3769 1.00869 11.7582 1.00869 12.1557C1.00869 12.5532 1.17436 12.9344 1.4693 13.2157C1.76641 13.4972 2.16846 13.6552 2.58755 13.6552C3.00665 13.6552 3.4087 13.4972 3.7058 13.2157L7.9688 9.15569L12.2318 13.2257C12.3761 13.3673 12.5493 13.4794 12.7406 13.555C12.932 13.6307 13.1376 13.6683 13.3448 13.6657C13.6561 13.6654 13.9603 13.5773 14.2191 13.4125C14.4779 13.2476 14.6795 13.0135 14.7986 12.7395C14.9177 12.4656 14.9489 12.1642 14.8882 11.8734C14.8276 11.5826 14.6778 11.3155 14.4578 11.1057L10.1948 7.03569Z" />
                        </svg>
                        <span class="modal__close-text">{{ translationsStore.getTranslation('Translate.Modal.Close').Value }}</span>
                    </span>
                </div>
            </div>
        </Teleport>
    </template>
</template>
<script>
import { setupSwipers } from '../../components/swiper';
import ParagraphItem from './paragraph-item.vue';
import { useContentStore, useTranslationsStore } from '../store';
import { useItem } from '../composables/item';
const { mapItems } = useItem();

export default {
    name: 'CaseEntrances',
    components: {
        ParagraphItem
    },
    props: {
        containerId: {
            type: String,
            default: '',
        },
        type: {
            type: String,
            default: '',
        },
        casePage: {
            type: Number,
            default: 0,
        },
        caseCategories: {
            type: String,
            default: '',
        },
        caseTags: {
            type: String,
            default: '',
        },
        listView: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            modalReady: false,
            baseUrl: '/dwapi/content',
            areaId: document.documentElement.dataset.areaId,
            caseList: null,
            selectedCase: null,
            selectedCaseId: null,
            translationsStore: null,
            currentCaseImage: null,
            mouseYPos: null,
            mouseXPos: null,
            mouseMoveHandler: null,
            allLoaded: false,
        };
    },
    computed: {
        filteredCases() {
            let filteredCases = this.caseList;

            if (this.caseCategories.length > 0 || this.caseTags.length > 0) {
                if (this.caseCategories.length > 0) {
                    const categories = this.caseCategories.split(',');
                    filteredCases = filteredCases.filter(x => x.Categories.some(z => categories.includes(z)));
                }

                if (this.caseTags.length > 0) {
                    const tags = this.caseTags.split(',');
                    filteredCases = filteredCases.filter(x => x.Tags.some(z => tags.includes(z)));
                }
            }

            return filteredCases;
        }
    },
    mounted() {
        this.translationsStore = useTranslationsStore();
        this.contentStore = useContentStore();

        const fetches = [this.translationsStore.fetchTranslations()];

        Promise.all(fetches).then(() => {
            this.modalReady = true;

            this.getCases().then(() => {
                setupSwipers('[data-action="case-entrance-swiper"]');
            });
        });

        if (window.location.hash.includes('modal=')) {
            this.getCase(window.location.hash.split('modal=')[1].replace('modal',''));
        }
    },
    methods: {
        async getCases() {
            const fetchUrl = `${this.baseUrl}/pages?itemtype=case${this.casePage != 0 ? `&pageid=${this.casePage}` : `&areaid=${this.areaId}`}`;

            await fetch(fetchUrl, {
                method: 'get',
                headers: {
                    'Content-Type': 'application/json',
                },
            }).then(response => response.json()).then(data => {
                const formattedCaseList = data.map(x => {
                    const fields = x.Item.Fields.map(field => {
                        if (field.SystemName == 'Name') {
                            return {
                                Name: field.Value
                            };
                        }

                        if (field.SystemName == 'Label') {
                            return {
                                Label: field.Value
                            };
                        }

                        if (field.SystemName == 'Image' && field.Value && field.Value.Fields) {
                            const imageField = field.Value.Fields.find(f => f.SystemName == 'Image');

                            if (imageField && imageField.Value.length > 0) {
                                return {
                                    ImagePath: `/admin/public/getimage.ashx?image=${encodeURIComponent(imageField.Value[0].Path)}&compression=100${imageField.Value[0].FocalX !== undefined ? `&x=${imageField.Value[0].FocalX}&y=${imageField.Value[0].FocalY}` : ''}&width=801&height=928&crop=7`
                                };
                            }
                        }

                        if (field.SystemName == 'Categories') {
                            if (field.Value && field.Value.SelectedValues) {
                                return {
                                    Categories: field.Value.SelectedValues
                                };
                            }
                        }

                        if (field.SystemName == 'Tags') {
                            if (field.Value && field.Value.SelectedValues) {
                                return {
                                    Tags: field.Value.SelectedValues
                                };
                            }
                        }

                        return undefined;
                    }).filter(item => item !== undefined);

                    fields.push({ PageId: x.ID});

                    return Object.assign({}, ...fields);
                });

                this.caseList = formattedCaseList;
            });
        },
        getCase(pageId) {
            const fetches = [this.contentStore.fetchParagraphs(pageId)];

            Promise.all(fetches)
                .then(() => {
                    const caseContent = mapItems(this.contentStore.getParagraphs(pageId));

                    if (caseContent.length > 0) {
                        history.pushState({}, document.title, `#modal=modal${pageId}`);

                        this.selectedCaseId = pageId;
                        this.selectedCase = caseContent;

                        const _this = this;

                        setTimeout(() => {
                            _this.addEvents();
                        }, 10);
                    }
                });
        },
        deselectCase() {
            this.removeEvents();
            this.selectedCaseId = null;
            this.selectedCase = null;
            this.resetHash();
        },
        resetHash() {
            history.pushState({}, document.title, window.location.pathname);
        },
        getModuleClass(paragraph) {
            const moduleClass = `theme${paragraph.Theme.SelectedValue} ${this.getModuleName(paragraph.systemName)}`;
            return moduleClass;
        },
        getModuleName(systemName) {
            const moduleSystemName = systemName.toLowerCase();

            switch (moduleSystemName) {
                case 'fullscreenvideo':
                    return 'full-screen-video';
                case 'imagegrid':
                    return 'image-grid';
                default:
                    return moduleSystemName;
            }
        },
        keyUpEvent(e) {
            if (e.key === 'Escape' && this.selectedCase !== null) {
                this.deselectCase();
            }
        },
        clickEvent(e) {
            const modalContent = e.target.closest('.modal__content');

            if (this.selectedCase && modalContent === null) {
                this.deselectCase();
            }
        },
        addEvents() {
            window.addEventListener('keyup', this.keyUpEvent);
            window.addEventListener('click', this.clickEvent);
        },
        removeEvents() {
            window.removeEventListener('keyup', this.keyUpEvent);
            window.removeEventListener('click', this.clickEvent);
        }
    }
};
</script>
